<template>
  <Loader
    :value="promises.fetch"
    :message="$t('loading', { resource: $tc('user', 2).toLowerCase() }) + '...'"
    class="users"
  >
    <div class="container view">
      <HeaderComponent :title="$metaInfo.title">
        <template #actions>
          <Actions placement="users" />
          <ButtonComponent
            theme="primary"
            :label="$t('create')"
            :icon="['fal', 'plus']"
            @click="$router.push({ name: 'user-create', query: { returnTo: $route.path } })"
          />
        </template>
      </HeaderComponent>
      <div class="users__content" v-if="items.length || states.fetch">
        <UserCard
          v-for="item in items"
          :key="item.id"
          :value="item"
          tag="router-link"
          :to="{ name: 'user-edit', params: { id: item.id } }"
        >
          <template #title>
            {{ item.name }}
          </template>
          <template #subtitle>
            <div data-field="email">{{ item.email }}</div>
            <div v-if="!item.isGuest && !item.isConfirmed" data-field="isConfirmed">
              <FontAwesomeIcon :icon="['fal', 'envelope']" style="margin-right: 3px" />
              <i>{{ $t('inviteSent') }}</i>
            </div>
            <Badge v-if="item.access.includes('owner')">{{ $t('accountOwner') }}</Badge>
            <Badge v-if="item.isGuest">{{ $t('guest') }}</Badge>
            <Badge v-if="item.demo" theme="warning">{{ $t('demo') }}</Badge>
            <template v-if="item.tags">
              <Badge v-for="tag in item.tags" theme="secondary">{{ tag }}</Badge>
            </template>
          </template>
        </UserCard>
      </div>
      <EmptyState
        v-else
        :title="$t('noX', { x: this.$tc('user', 2).toLowerCase() })"
        :subtitle="$t('usersEmptyState')"
        :icon="['fal', 'users']"
        action-portal
      />
    </div>
  </Loader>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import HeaderComponent from '@/components/Header'
import UserCard from '@/components/User/Card'
import Badge from '@/components/Badge'
import Card from '@/components/Card'
import Actions from '@/components/Actions'
import EmptyState from '@/components/EmptyState'

export default {
  computed: {
    ...mapState('User', ['promises', 'items', 'states']),
  },
  methods: {
    ...mapActions('User', ['fetch']),
  },
  created() {
    this.fetch()
  },
  metaInfo() {
    return {
      title: this.$tc('user', 2),
    }
  },
  components: {
    UserCard,
    Card,
    HeaderComponent,
    Badge,
    Actions,
    EmptyState,
  },
}
</script>

<style lang="scss">
.users {
  background-color: $background-grey;

  &__content {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
    grid-gap: $form-gap;
  }

  .user-card {
    &__subtitle {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 0.5rem;

      opacity: 1;

      [data-field='isConfirmed'],
      [data-field='email'] {
        opacity: 0.8;
      }
    }
  }
}
</style>
